const routeMain = () => "/consent";

export default routeMain;
